export function toNonNegativeNumber(value) {
  const parsed = Number(value);
  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
}

// Gross margin is potential front-end gross divided by target retail price.
export function calculateDealerPlanning({ targetRetail, recon, targetGross, offer }) {
  const retail = toNonNegativeNumber(targetRetail);
  const reconAmount = toNonNegativeNumber(recon);
  const grossTarget = toNonNegativeNumber(targetGross);
  const offerAmount = toNonNegativeNumber(offer);
  const maximumAcquisition = retail - reconAmount - grossTarget;
  const potentialGross = retail - offerAmount - reconAmount;
  const potentialGrossMarginPercent = retail > 0 ? (potentialGross / retail) * 100 : 0;

  return {
    maximumAcquisition,
    potentialGross,
    potentialGrossMarginPercent,
  };
}
